import getApiClient, { getAnnonymousApiClient } from "./../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications
} from "../../../notifications/ducks/actions";

export function confirmEmail(userId, token) {
  return (dispatch) => {
    dispatch({
      type: "CONFIRM_EMAIL",
      payload: getAnnonymousApiClient().post(`/account/confirmEmail`, {userId, token}),
    }).then((response) => {      
      dispatch(showInfo(`Successfully confirmed email`));
    })
    .catch((response) => {
      dispatch(showError(`Error confirming email`));
    })
    .then((response) => {
      dispatch(clearNotifications());
    });
  };
}
